/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliRefreshTokenRequestDto } from '../../models/amoxcalli-refresh-token-request-dto';

export interface ApiRefreshTokenRevokePost$Params {
      body?: AmoxcalliRefreshTokenRequestDto
}

export function apiRefreshTokenRevokePost(http: HttpClient, rootUrl: string, params?: ApiRefreshTokenRevokePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiRefreshTokenRevokePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiRefreshTokenRevokePost.PATH = '/api/refresh-token/revoke';
